export const darkenHexColor = (hex: string, amount: number = 20) => {
    let r: number = parseInt(hex.slice(1, 3), 16);
    let g: number = parseInt(hex.slice(3, 5), 16);
    let b: number = parseInt(hex.slice(5, 7), 16);

    r = Math.max(0, r - amount);
    g = Math.max(0, g - amount);
    b = Math.max(0, b - amount);

    return "#" + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
  }
export const darkenRgbColor = (rgb: string, amount: number = 20) => {
    const [r, g, b] = rgb.match(/\d+/g)?.map(Number) ?? [0, 0, 0];

    return `rgb(${Math.max(0, r - amount)}, ${Math.max(0, g - amount)}, ${Math.max(0, b - amount)})`;
  }

export const getRelativeLuminance = (color: string): number => {
    // Check if the color is in hexadecimal format
    if (color.startsWith('#')) {
      // Convert hexadecimal to RGB
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      return calculateRelativeLuminanceFromRGB(r, g, b);
    }

    // Check if the color is in RGB format
    const rgbMatch = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (rgbMatch) {
      const r = parseInt(rgbMatch[1], 10);
      const g = parseInt(rgbMatch[2], 10);
      const b = parseInt(rgbMatch[3], 10);

      return calculateRelativeLuminanceFromRGB(r, g, b);
    }

    // Invalid color format
    throw new Error('Invalid color format');
  }
  const calculateRelativeLuminanceFromRGB = (r: number, g: number, b: number): number => {
    const luminance = 0.2126 * Math.pow(r / 255, 2.2) + 0.7152 * Math.pow(g / 255, 2.2) + 0.0722 * Math.pow(b / 255, 2.2);
    return luminance;
}

export const getInitials = (senderAddress: String): string => {
    // Extract the name part before the email address (before <)
    const namePart = senderAddress.split('<')[0].trim();
    
    // Split the name into words
    const words = namePart.split(' ').filter(word => word.length > 0);
    
    if (words.length === 0) return '??';
    
    // Get first letter of first word
    const firstInitial = words[0].charAt(0).toUpperCase();
    
    // If there's a second word, get its first letter, otherwise return just the first initial
    if (words.length > 1) {
      const secondInitial = words[1].charAt(0).toUpperCase();
      return `${firstInitial}${secondInitial}`;
    }
    
    return firstInitial;
  };